import { useState, useEffect } from "react";
import Header from "../components/navbar/Header";
import Footer from "../components/footer/Footer";
import { Link, useNavigate, useParams } from "react-router-dom";
import EnquiryForm from "../components/form/Enquiry";
import { models } from "../json";
import CurrencyFormatter from "../components/CurrencyFormatter";
import { Helmet } from "react-helmet";
import { BiDownload } from "react-icons/bi";
import EmiCalculator from "../components/EmiCalculator";
import whatsappSvg from "../assets/whatsapp.svg";
import { HiMiniWrenchScrewdriver } from "react-icons/hi2";
import { RiSteering2Line } from "react-icons/ri";
/* ================= DETAIL PAGE ================= */

const Detail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [openEnquiry, setOpenEnquiry] = useState(false);
  const [car, setCar] = useState(null);
  const [activeColor, setActiveColor] = useState(0);
  const [showAll, setShowAll] = useState(false);
  const [selectedVariantIndex, setSelectedVariantIndex] = useState(0);
  const [openEmi, setOpenEmi] = useState(false);

  useEffect(() => {
    const selectedCar = models.find((item) => item.id === id);
    if (!selectedCar) navigate("/");
    else setCar(selectedCar);
  }, [id, navigate]);

  // ⛔ STOP RENDERING UNTIL car EXISTS
  if (!car || !car.variants || car.variants.length === 0) return null;

  // ✅ SAFE TO USE NOW
  const selectedVariant = car.variants[selectedVariantIndex];
  const currentColor = car.colors?.[activeColor];
  return (
    <>
      <Helmet>
        <title>{car.metaTitle}</title>
        <meta name="description" content={car.metaDescription} />
      </Helmet>
      <Header />
      <div className="bg-gray-50 relative overflow-visible">
        <div className="max-w-screen-xl mx-auto px-4 py-8">
          {/* BREADCRUMB */}
          {/* <p className="text-sm text-gray-600 mb-6">
            <Link to="/">Home</Link> / {car.category} /{" "}
            <span className="text-red-600">{car.name}</span>
          </p> */}

          {/* ================= HERO SECTION ================= */}
          <div className=" rounded-xl p-6 grid grid-cols-1 lg:grid-cols-2 gap-10">
            {/* left – PRICE INFO */}
            <div className="space-y-5">
              <h2 className="text-2xl font-semibold">
                {car.name} Ex-Showroom Price
              </h2>

              <p className="text-red-600 text-2xl font-bold">
                {CurrencyFormatter.format(car.price)}*
              </p>

              {/* SPECS */}
              <div className="flex   border-t pt-4 text-sm">
                <Spec
                  label="Engine"
                  icon="https://www.varunmaruti.com/assets/maintemp/images/products/speed.png"
                  value={car.engine?.[0]?.value}
                />
                <Spec
                  label="Engine Type"
                  icon="https://www.varunmaruti.com/assets/maintemp/images/products/fuel.png"
                  value={car.engine?.[1]?.value}
                />
                <Spec
                  label="Power"
                  icon="https://www.varunmaruti.com/assets/maintemp/images/products/engine.png"
                  value={car.engine?.[2]?.value}
                />
              </div>

              {/* BUTTONS */}
              <div className="flex gap-3 pt-6">
                <button
                  onClick={() => setOpenEmi(true)}
                  className="border border-black px-4 py-2 rounded-md text-sm hover:bg-[#253E72] hover:text-white"
                >
                  EMI Calculator
                </button>

                <button
                  onClick={() => setOpenEnquiry(true)}
                  className="bg-[#DC2627] hover:bg-[#253E72] text-white px-4 py-2 rounded-md text-sm"
                >
                  Get On Road Price
                </button>
              </div>
              <div className="space-y-10">
                <p className="">
                  Our professional and well-trained staff is ready to assist you
                </p>
                {car.brochure && (
                  <a
                    href={car.brochure}
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-2 border  text-white px-4 py-2 rounded-md text-sm w-40 bg-red-600 hover:bg-[#253E72] hover:duration-200"
                  >
                    <BiDownload /> View Brochure
                  </a>
                )}
              </div>
            </div>

            {/* Right– IMAGE & COLORS */}
            <div>
              <img
                src={currentColor?.img}
                alt={car.name}
                className="w-full max-h-[320px] object-contain mx-auto"
              />

              <p className="text-center text-sm mt-2 text-gray-600">
                {currentColor?.name}
              </p>

              {/* COLORS */}
              <div className="flex justify-center gap-3 mt-4">
                {car.colors.map((c, i) => (
                  <button
                    key={i}
                    onClick={() => setActiveColor(i)}
                    className={`w-4 h-4 rounded-full border ${
                      activeColor === i ? "ring-2 ring-black" : ""
                    }`}
                    style={{ backgroundColor: c.colorCode }}
                  />
                ))}
              </div>

              {/* VARIANT */}
              <div className="mt-6 max-w-xs mx-auto">
                <label className="text-sm font-medium">Select Variant</label>

                <select
                  className="w-full border mt-1 rounded-md px-3 py-2 text-sm"
                  value={selectedVariantIndex}
                  onChange={(e) =>
                    setSelectedVariantIndex(Number(e.target.value))
                  }
                >
                  {car.variants.map((v, i) => (
                    <option key={i} value={i}>
                      {v.strong ? `${v.strong} || ` : ""}
                      {v.variant}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* ================= KEY SPECIFICATIONS ================= */}
          <div className="mt-12">
            <h3 className="text-xl font-semibold mb-4">
              {selectedVariant.variant} Key Specifications
            </h3>

            <div className="bg-white  grid grid-cols-2 md:grid-cols-3 p-6">
              <Spec2
                label="Price"
                icon="https://www.varunmaruti.com/assets/maintemp/images/products/price-tag.png"
                value={`${CurrencyFormatter.format(
                  selectedVariant.price,
                )} Lakhs onwards`}
              />
              <Spec2
                label="Mileage"
                value={selectedVariant.mileage}
                icon="https://www.varunmaruti.com/assets/maintemp/images/products/mileage.png"
              />
              <Spec2
                label="Seating Capacity"
                value={selectedVariant.seating}
                icon="https://www.varunmaruti.com/assets/maintemp/images/products/seat.png"
              />
              <Spec2
                label="Engine"
                value={selectedVariant.engine}
                icon="https://www.varunmaruti.com/assets/maintemp/images/products/engine-o.png"
              />
              <Spec2
                label="Fuel Type"
                value={selectedVariant.fuelType}
                icon="https://www.varunmaruti.com/assets/maintemp/images/products/fueltype.png"
              />
              <Spec2
                label="Transmission"
                value={selectedVariant.transmission}
                icon="https://www.varunmaruti.com/assets/maintemp/images/products/gearbox.png"
              />
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-red-900 via-red-800 to-gray-900 py-16 mt-16">
          <div className="max-w-4xl mx-auto px-4">
            <h2 className="text-white text-2xl font-semibold mb-8 text-center">
              {car.name} Price
            </h2>

            {(showAll ? car.variants : car.variants.slice(0, 3)).map((v, i) => (
              <div
                key={i}
                className="bg-gray-100 rounded-lg shadow-md mb-6 overflow-hidden"
              >
                {/* TOP FEATURE STRIP */}
                <div className="bg-gray-200 px-6 py-4 border-l-4 border-teal-500">
                  <h3 className="font-semibold text-gray-800">{v.variant}</h3>

                  {/* {v.features && (
                    <p className="text-sm text-gray-600 mt-1 line-clamp-2">
                      {v.features}
                    </p>
                  )} */}
                </div>

                {/* TABLE HEADER */}
                <div className="grid grid-cols-2 px-6 py-3 text-sm text-gray-500 border-b">
                  <span>
                    {v.engine}, {v.transmission}
                  </span>
                  <span className="text-right">Avg Ex. Showroom Price</span>
                </div>

                {/* VERSION ROW */}
                <div className="grid grid-cols-2 px-6 py-4 items-center">
                  <div>
                    {/* <p className="font-semibold text-gray-800">{v.variant}</p> */}
                    <FeatureList items={v.features} />
                  </div>

                  <div className="text-right">
                    <p className="font-semibold text-gray-900">
                      {CurrencyFormatter.format(v.price)} Lakhs
                    </p>
                    <button
                      onClick={() => setOpenEnquiry(true)}
                      className="text-red-600 text-xs mt-1 hover:underline"
                    >
                      Get Offers
                    </button>
                  </div>
                </div>
              </div>
            ))}

            {car.variants.length > 3 && (
              <div className="text-center mt-6">
                <button
                  onClick={() => setShowAll(!showAll)}
                  className="bg-white text-blue-900 font-semibold px-6 py-2 rounded-md shadow hover:bg-gray-100 transition"
                >
                  {showAll ? "View Less" : "View More"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      {openEnquiry && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
          <EnquiryForm
            modelName={`${car.name} - ${selectedVariant.variant}`}
            onClose={() => setOpenEnquiry(false)}
          />
        </div>
      )}
      {openEmi && (
        <EmiCalculator
          price={selectedVariant.price}
          onClose={() => setOpenEmi(false)}
        />
      )}{" "}
      <div className="fixed z-20 space-y-2 -translate-y-1/2 right-1 bottom-1/3 lg:right-0 ">
        <Link
          to={"/book-a-service"}
          className="flex items-center flex-grow gap-2 px-4 py-2 text-sm text-center text-white duration-300 delay-100 translate-x-32 bg-[#2E2583] border border-[#2E2583] rounded-l-full shadow-lg cursor-pointer hover:translate-x-0 group"
        >
          <HiMiniWrenchScrewdriver className="h-5 w-5" />

          <p className="opacity-0 group-hover:opacity-100"> Book A Service</p>
        </Link>
        <Link
          to={"/contact-us"}
          className="flex items-center flex-grow gap-2 px-4 py-2 text-sm text-center text-white duration-300 delay-100 translate-x-32 bg-[#2E2583] border border-[#2E2583] rounded-l-full shadow-lg cursor-pointer hover:translate-x-0 group"
        >
          <RiSteering2Line className="h-6 w-6" />

          <p className="opacity-0 group-hover:opacity-100">
            {" "}
            Book A Test Drive
          </p>
        </Link>
      </div>
      <div className="fixed bottom-5 right-5 z-[9999]">
        <a
          href="https://api.whatsapp.com/send/?phone=+919912341531&text=Hello%20%F0%9F%91%8B%20Welcome%20to%20GEM%20Motors!%20What's%20your%20name%3F&app_absent=0"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="bg-green-600 p-2.5 rounded-full animate-bounce">
            <img
              src={whatsappSvg}
              loading="lazy"
              className="h-6 w-6"
              alt="whatsapp"
            />
          </div>
        </a>
      </div>
      <Footer />
    </>
  );
};

/* ================= COMPONENTS ================= */

const Spec = ({ label, value, icon }) => (
  <div
    className=" items-center  
    px-5 py-4  
      transition"
  >
    <div className="flex items-center space-x-3">
      {/* Icon */}
      <img src={icon} alt={label} className="w-8 h-12 object-contain" />
      <p className="text-lg text-gray-500 font-medium">{label}</p>
    </div>
    {/* Text */}
    <p className="text-base font-semibold text-gray-900">{value}</p>
  </div>
);

const Spec2 = ({ label, value, icon }) => (
  <div
    className=" items-center  bg-white
    px-5 py-4  border
      transition"
  >
    <div className="flex items-center space-x-3">
      {/* Icon */}
      <img src={icon} alt={label} className="w-8 h-12 object-contain" />
      <p className="text-lg text-gray-500 font-medium">{label}</p>
    </div>
    {/* Text */}
    <p className="text-base font-semibold text-gray-900">{value}</p>
  </div>
);

export default Detail;

export function FeatureList({ items = [], bullet = true }) {
  return (
    <ul
      className={`text-xs text-gray-500 mt-1 ${
        bullet ? "list-disc pl-4" : "space-y-1"
      }`}
    >
      {items.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ul>
  );
}
